// Distance (px) the cloud is kept away from the activator.
const GAP_IN_PX: number = 15;

// Distance (px) the cloud is kept away from the viewport edges.
const VIEWPORT_PADDING_IN_PX: number = 8;

// Arrow square side length (px). Keep in sync with `$corner-size` in _variables.scss.
const ARROW_SIZE_IN_PX: number = 15;

export { GAP_IN_PX, VIEWPORT_PADDING_IN_PX, ARROW_SIZE_IN_PX };
